import {
  Box,
  Button,
  Popover,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ConfirmBox from "../../components/ConfirmBox";
import { getWithdrawQuotation, setProlongQuotation } from "../../apis/buyersGuideApis";
import { useDispatch } from "react-redux";
import { toastActions } from "../../_actions";

const QuotationActionsButtonPopover = ({anchorEl,mode,onClose ,quotationDetails,fetchQuotationDetails}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch()
  const isOpen = Boolean(anchorEl);
  const isWithdraw = mode === "withdraw";
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState({ prolong: false, withdraw: false });
  const [confirmBoxOpen, setConfirmBoxOpen] = useState(false);

  const handleClose = () => {
    setInputValue("");
    setConfirmBoxOpen(false);
    onClose();
  };

  const handleProlong = async () => {
    try {
      setLoading((prev) => ({ ...prev, prolong: true }));
      await setProlongQuotation(quotationDetails?.quote?.id, inputValue.toString());
      await fetchQuotationDetails(true);
       dispatch(toastActions.success(t("general.prolong.success")));
      handleClose();
    } catch (err) {
       dispatch(toastActions.error(t("error.header")));

    } finally {
      setLoading((prev) => ({ ...prev, prolong: false }));
    }
  };

  const handleWithdraw = async () => {
    try {
      setLoading((prev) => ({ ...prev, withdraw: true }));
      await getWithdrawQuotation(quotationDetails?.quote?.id);
      await fetchQuotationDetails(true);
      dispatch(toastActions.success(t("general.withdraw.success")));
      handleClose();
    } catch (err) {
      dispatch(toastActions.error(t("error.header")));
    } finally {
      setLoading((prev) => ({ ...prev, withdraw: false }));
    }
  };

  return (
    <>
        <Popover
          id="timeline-action-popover"
          open={isOpen}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{ mt: 1 }}
        >
        <Box sx={{ maxWidth: 275, p: 1.5 }}>
          {mode === 'prolong' && (
            <>
              <Typography variant="caption">
                {t("general.prolong.popover.title")}
              </Typography>
              <TextField
                sx={{ mt: 2 }}
                fullWidth
                size="small"
                label={t("general.days")}
                type="number"
                value={inputValue}
                onChange={(e) => {
                  const val = e.target.value;
                  const num = Number(val);
                  if (!val) return setInputValue("");
                  if (num >= 2 && num <= 365) setInputValue(val);
                }}
                inputProps={{ min: 2, max: 365 }}
                InputLabelProps={{ shrink: true }}
                required
              />
            </>
          )}

          {mode === 'withdraw' && (
            <TextField
              sx={{ mt: 2 }}
              fullWidth
              size="small"
              label={t("general.reason")}
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
          )}

          <Stack
            direction="row"
            sx={{ mt: 2, columnGap: 1, justifyContent: "center" }}
          >
            <Button variant="outlined" onClick={handleClose}>
              {t("general.cancel")}
            </Button>

            <Button
              variant="contained"
              disabled={loading.prolong || loading.withdraw || inputValue === ""}
              onClick={() => {
                if (isWithdraw) {
                  setConfirmBoxOpen(true);
                } else {
                  handleProlong();
                }
              }}
            >
              {t("general.confirm")}
            </Button>
          </Stack>
        </Box>

        </Popover>

      {confirmBoxOpen && (
        <ConfirmBox
          open
          title={t("general.warning")}
          description={t("general.withdraw.warning.description")}
          okText={t("general.confirm")}
          cancelText={t("general.cancel")}
          onOk={handleWithdraw}
          onCancel={handleClose}
        />
      )}
    </>
  );
};

export default QuotationActionsButtonPopover;
